<template>
  <v-footer
    :app="fixed"
    class="c-footer"
    :fixed="fixed"
    height="56"
    inset
    padless
  >
    <v-container class="text-center pa-0">
      <v-row class="mx-auto my-0" align="center" justify="space-around">
        <v-col class="pa-0">
          <v-btn
            class="ma-auto"
            rounded
            :href="mailTo">
            {{ $t('footer.contact') }}
          </v-btn>
        </v-col>
        <v-col class="pa-0">
          <p class="ma-auto d-inline">
            &copy;{{ new Date().getFullYear() }}&nbsp;
            <strong>
              <a :href="orgLink" target="_blank" rel="noopener noreferrer">
                {{ orgName }}
              </a>
            </strong>
          </p>
        </v-col>
        <v-col class="pa-0">
          <v-btn
            v-for="network in socialNetworks"
            :key="network.name"
            class="mx-4"
            dark
            fab
            :href="network.url"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-icon size="40px">
              {{ network.icon }}
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'AppFooter',

  components: {},

  props: {
    fixed: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data: function () {
    return {
      socialIcons: {
        facebook: 'mdi-facebook',
        linkedIn: 'mdi-linkedin'
      }
    }
  },

  computed: {
    orgName() {
      return this.$store.state.orgStore.orgName
    },

    orgLogo() {
      return this.$store.state.orgStore.orgLogo
    },

    orgLink() {
      return this.$store.state.orgStore.orgInfo.website
    },

    socialNetworks() {
      const networks = []
      for (let key in this.$store.state.orgStore.orgInfo.social) {
        if (this.$store.state.orgStore.orgInfo.social[key]) {
          networks.push({
            name: key,
            icon: this.socialIcons[key],
            url: this.$store.state.orgStore.orgInfo.social[key]
          })
        }
      }
      return networks
    },

    mailTo() {
      return `mailto:${this.$store.state.orgStore.orgName}<${this.$store.state.orgStore.orgInfo.email}>`
    }
  },

  methods: {}
}
</script>

<style lang="css" scoped>
.c-footer {
  border-color: var(--v-primary-base) !important;
  border-top: solid 2px;
}
</style>
